import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './core/guard/auth.guard';
import { LayoutComponent } from './layout/layout.component';
import { pagenotfoundComponent } from './page-not-found/page-not-found.component';
const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'sitemap',
        loadChildren: () => import('./sitemap/sitemap.module').then(m => m.sitemapModule),
      },
      {
        path: 'photo-gallery',
        loadChildren: () => import('./photo-gallery/photo-gallery.module').then(m => m.PhotogalleryModule),
      },
      {
        path: 'video-gallery',
        loadChildren: () => import('./video-gallery/video-gallery.module').then(m => m.VideogalleryModule),
      },
      {
        path: 'news-update',
        loadChildren: () => import('./news-update/news-update.module').then(m => m.NewsupdateModule),
      },
      // {
      //   path: 'aggrigate',
      //   loadChildren: () => import('./aggrigate/aggrigate.module').then(m => m.AggrigateModule),
      // },
      {
        path: 'Pendencyreport',
        loadChildren: () => import('./Pendencyreport/Pendencyreport.module').then(m => m.PendencyreportModule),
      },
      {
        path: 'Pendencyreportbarchart',
        loadChildren: () => import('./Pendencyreportbarchart/Pendencyreportbarchart.module').then(m => m.PendencyreportbarchartModule),
      },
      {
        path: 'statewisereportbarchart',
        loadChildren: () => import('./statewisereportbarchart/statewisereportbarchart.module').then(m => m.statewisereportbarchartModule),
      },
      {
        path: 'faqs',
        loadChildren: () => import('./faqs/faqs.module').then(m => m.faqsModule),
      },
      {
        path: 'onlineapplicationguide',
        loadChildren: () => import('./onlineapplicationguide/onlineapplicationguide.module').then(m => m.onlineapplicationguideModule),
      },
      {
        path: 'findNearestMedicalAutority',
        loadChildren: () => import('./findNearestMedicalAutority/findNearestMedicalAutority.module').then(m => m.findNearestMedicalAutorityModule),
      },
      {
        path: 'medicalcamps-hospital',
        loadChildren: () => import('./medicalcamps-hospital/medicalcamps-hospital.module').then(m => m.medicalcampsModule)
      },
      {
        path: 'disibility-scheme',
        loadChildren: () => import('./disibility-scheme/disibility-scheme.module').then(m => m.disibilityschemeModule)
      },
      {
        path: 'district-wallfare-office',
        loadChildren: () => import('./district-wallfare-office/district-wallfare-office.module').then(m => m.districtwallfareofficeModule)
      },
      {
        path: 'registration',
        loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationModule)
      },

      {
        path: 'feedback',
        loadChildren: () => import('./feedback/feedback.module').then(m => m.feedbackModule),
      },
      {
        path: 'dashboardchart',
        loadChildren: () => import('./dashboardchart/dashboardchart.module').then(m => m.dashboardchartModule),
      },
      {
        path: 'dashboardbarchart',
        loadChildren: () => import('./dashboardbarchart/dashboardbarchart.module').then(m => m.DashboardbarchartModule),
      },
      {
        path: 'track-your-application',
        loadChildren: () => import('./track-your-application/track-your-application.module').then(m => m.trackyourapplicationModule),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'Applyudid',
        loadChildren: () => import('./Applyudid/Applyudid.module').then(m => m.ApplyudidModule),
      },
      {
        path: 'Applyforudid',
        loadChildren: () => import('./Applyforudid/Applyforudid.module').then(m => m.ApplyforudidModule),
      },
      {
        path: 'Aadhaarekyc',
        loadChildren: () => import('./Aadhaarekyc/Aadhaarekyc.module').then(m => m.AadhaarekycModule),
      },
      {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
      },
      {
        path: 'Statewisecodinator1',
        loadChildren: () => import('./Statewisecodinator/Statewisecodinator.module').then(m => m.StatewisecodinatorModule),
      },
      {
        path: 'statewisereport',
        loadChildren: () => import('./statewisereport/statewisereport.module').then(m => m.statewisereportModule),
      },
      {
        path: ':slug',
        loadChildren: () => import('./cms/cms.module').then(m => m.cmsModule),
      },

      {
        path: '**',
        component: pagenotfoundComponent,
      },
    ]
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
